import { render, staticRenderFns } from "./AssignEmployee.vue?vue&type=template&id=6e84039b&scoped=true&"
import script from "./AssignEmployee.vue?vue&type=script&lang=js&"
export * from "./AssignEmployee.vue?vue&type=script&lang=js&"
import style0 from "./AssignEmployee.vue?vue&type=style&index=0&id=6e84039b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84039b",
  null
  
)

export default component.exports